<div class="flex flex-col h-full space-y-6">

  <div class="flex flex-wrap gap-2 pb-2 border-b border-gray-100">
    <button (click)="crerDossier()" [disabled]="buttonDisabled"
      class="flex flex-col items-center justify-center p-3 text-xs font-medium text-gray-600 transition-all rounded-xl hover:bg-indigo-50 hover:text-indigo-600 disabled:opacity-50">
      <mat-icon class="!w-5 !h-5 !text-lg mb-1">create_new_folder</mat-icon>
      Nouveau
    </button>

    <button (click)="renommer()" [disabled]="buttonDisabled"
      class="flex flex-col items-center justify-center p-3 text-xs font-medium text-gray-600 transition-all rounded-xl hover:bg-indigo-50 hover:text-indigo-600 disabled:opacity-50">
      <mat-icon class="!w-5 !h-5 !text-lg mb-1">border_color</mat-icon>
      Renommer
    </button>

    <button (click)="addModele()" [disabled]="buttonDisabled"
      class="flex flex-col items-center justify-center p-3 text-xs font-medium text-gray-600 transition-all rounded-xl hover:bg-indigo-50 hover:text-indigo-600 disabled:opacity-50">
      <mat-icon class="!w-5 !h-5 !text-lg mb-1">bookmark</mat-icon>
      Modèle
    </button>

    <button (click)="supprimer()" [disabled]="buttonDisabled"
      class="flex flex-col items-center justify-center p-3 text-xs font-medium text-red-600 transition-all rounded-xl hover:bg-red-50 disabled:opacity-50">
      <mat-icon class="!w-5 !h-5 !text-lg mb-1">delete</mat-icon>
      Supprimer
    </button>


    <button (click)="supprimerModel()" [disabled]="buttonDisabled"
      class="flex flex-col items-center justify-center p-3 text-xs font-medium text-red-600 transition-all rounded-xl hover:bg-red-50 disabled:opacity-50">
      <mat-icon class="!w-5 !h-5 !text-lg mb-1">delete</mat-icon>
      Supprimer modèle
    </button>
  </div>

  <div id="documentColl" class="demo flex-grow border border-gray-100 rounded-xl bg-gray-50/50 p-4 overflow-y-auto">
  </div>

  <div class="grid grid-cols-2 gap-4 pt-4">
    <div class="space-y-1">
      <label class="text-xs font-semibold text-gray-500 uppercase">Français</label>
      <input [(ngModel)]="txtFrancais"
        class="w-full px-4 py-2.5 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 outline-none transition"
        placeholder="Nom français" />
    </div>

    <div class="space-y-1">
      <label class="text-xs font-semibold text-gray-500 uppercase">Anglais</label>
      <input [(ngModel)]="txtAnglais"
        class="w-full px-4 py-2.5 rounded-xl border border-gray-300 focus:ring-2 focus:ring-indigo-500 outline-none transition"
        placeholder="English name" />
    </div>
  </div>

  <button (click)="enregistrerLangue()"
    class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 rounded-xl transition-all shadow-lg shadow-indigo-200">
    Enregistrer les modifications
  </button>
</div>

<div *ngIf="!exist" class="absolute top-0 left-0 w-full h-1 bg-gray-100 overflow-hidden">
  <div class="h-full bg-indigo-600 animate-pulse"></div>
</div>